import { n as e } from "./context-BrD4AniQ.js";
import { a as t } from "./maplibre-CUYkxr-D.js";
import { n, t as r } from "./MarkerIcon-Bc3X9WQk.js";
import { t as i } from "./Cluster-BHQcO6iC.js";
import "react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/Map/Root/Markers/Maptiler/index.tsx
function s({ clusters: s, colors: c, clusterIcon: l, onClick: u, doesSuperclusterContainActiveMarker: d }) {
	let { activeMarker: f, zoom: p } = e(), m = (e) => (t) => {
		t.originalEvent.stopPropagation(), !e.properties.disableClick && u?.(e);
	};
	return s?.map((e, s) => {
		let u = e.geometry.coordinates[0], h = e.geometry.coordinates[1];
		return /* @__PURE__ */ o(t, {
			anchor: "bottom",
			longitude: u,
			latitude: h,
			onClick: m(e),
			children: [e.properties.cluster && e.properties.cluster_id && /* @__PURE__ */ a(i, {
				colors: c,
				icon: l,
				isActive: d(e.properties.cluster_id)
			}), !e.properties.cluster && /* @__PURE__ */ a("div", {
				className: n,
				style: e.properties.defaultColor ? {} : {
					"--background": c?.background,
					"--fill": c?.fill
				},
				"data-is-cluster": !!e.properties.cluster,
				"data-is-zoomed-out": p < 10,
				"data-is-active": f?.id === e.properties.id,
				children: /* @__PURE__ */ a(r, { icon: e.properties.icon })
			})]
		}, `map-marker-${u}-${h}-${s}`);
	});
}
//#endregion
export { s as default };
